<template>
  <v-dialog v-model="isOpen"
            @click:outside.prevent="closeModal"
            max-width="350">
    <v-card>
      <v-toolbar color="grey lighten-3 px-3" flat height="50">
        <v-toolbar-title>Settings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>$close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form ref="settingsForm" class="pa-5">
        <v-row class="mb-2">
          <v-col cols="5" class="d-flex align-center">
            <div class="body-2 font-weight-bold">Show Days</div>
          </v-col>
          <v-col cols="7">
            <v-text-field label="Show Days"
                          v-model="settingsFormData.days"
                          :rules="daysRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn @click="formSubmit">Apply Settings</v-btn>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'MainRotaSettingsDialog',
    props: ['isOpen', 'closeModal', 'defaultSettings'],
    data: () => ({
      settingsFormData: {},
      daysRules: [
        val => !!val || 'Days are required!',
        val => (Number(val) === 0) || !!Number(val) || 'Please enter only number',
        val => (Number(val) > 0 && Number(val) < 8) || 'Please choose 1 to 7 days'
      ]
    }),
    computed: {
    },
    methods: {
      formSubmit () {
        if (this.$refs.settingsForm.validate()) {
          localStorage.setItem('mainRotaTableSettings', JSON.stringify(this.settingsFormData))
          this.$emit('change:settings', this.settingsFormData)
          this.closeModal()
        }
      }
    },
    mounted () {
      this.settingsFormData = { ...this.defaultSettings }
    }
  }
</script>
